/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coaching_Workouts_30Inputs */

const en_us2_coaching_workouts_30 = /** @type {(inputs: Coaching_Workouts_30Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workouts in 30 days: ${i?.count}`)
};

const pt_br2_coaching_workouts_30 = /** @type {(inputs: Coaching_Workouts_30Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treinos em 30 dias: ${i?.count}`)
};

const pt_pt2_coaching_workouts_30 = /** @type {(inputs: Coaching_Workouts_30Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treinos em 30 dias: ${i?.count}`)
};

/** @type {(inputs: Coaching_Workouts_30Inputs) => LocalizedString} */
const es_419_coaching_workouts_30 = en_us2_coaching_workouts_30;

/** @type {(inputs: Coaching_Workouts_30Inputs) => LocalizedString} */
const fr_fr2_coaching_workouts_30 = en_us2_coaching_workouts_30;

/** @type {(inputs: Coaching_Workouts_30Inputs) => LocalizedString} */
const de_de2_coaching_workouts_30 = en_us2_coaching_workouts_30;

/** @type {(inputs: Coaching_Workouts_30Inputs) => LocalizedString} */
const it_it2_coaching_workouts_30 = en_us2_coaching_workouts_30;

/**
* | output |
* | --- |
* | "Workouts in 30 days: {count}" |
*
* @param {Coaching_Workouts_30Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_workouts_30 = /** @type {((inputs: Coaching_Workouts_30Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Workouts_30Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_workouts_30(inputs)
	if (locale === "es-419") return es_419_coaching_workouts_30(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_workouts_30(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_workouts_30(inputs)
	if (locale === "de-DE") return de_de2_coaching_workouts_30(inputs)
	if (locale === "it-IT") return it_it2_coaching_workouts_30(inputs)
	return en_us2_coaching_workouts_30(inputs)
});
export { coaching_workouts_30 as "coaching.workouts_30" }